// RotatingCube.jsx
import React from 'react';
import './RotatingCube.css';

const RotatingCube = () => {
  return (
    <>
      {/* 第一個旋轉立方體 */}
      <div className='rotating-cube-wrapper cube-1'>
        <div className='rotating-cube clockwise'>
          <div className='cube-face front'></div>
          <div className='cube-face back'></div>
          <div className='cube-face right'></div>
          <div className='cube-face left'></div>
          <div className='cube-face top'></div>
          <div className='cube-face bottom'></div>
        </div>
      </div>

      {/* 第二個旋轉立方體 */}
      <div className='rotating-cube-wrapper cube-2'>
        <div className='rotating-cube counter-clockwise'>
          <div className='cube-face front'></div>
          <div className='cube-face back'></div>
          <div className='cube-face right'></div>
          <div className='cube-face left'></div>
          <div className='cube-face top'></div>
          <div className='cube-face bottom'></div>
        </div>
      </div>
    </>
  );
};

export default RotatingCube;
